<template>
    <div class="nav-header">
        <div class="sub-item">
            <img class="menu-icon" @click="changeSlider" :src="require('../../assets/icon/left-menu.png')" />
        </div>
        <div class="main-item">
            <img class="main-icon" :src="require('../../assets/icon/top-icon.png')" />
        </div>
        <div class="sub-item right-item">
            <div class="lan-box" v-if="accountid == 0" @click="changeLan">
                <img class="sub-icon" v-for="(item, index) in lanData" :key="index + 1" v-if="lanCode == item.code"
                    :src="item.img" />
            </div>
            <div class="lan-masking" v-if="isShowLan" @click="changeLan">
                <div class="lan-modal" @click.stop="func1()">
                    <div class="lan-item" v-for="(item, index) in lanData" @click="setLan(item.code)">
                        <img class="icon" :src="item.img" />
                        <div>{{ item.title }}</div>
                    </div>
                </div>
            </div>
            <div class="wallert" v-if="accountid != 0">
                <div>฿{{ amount }}</div>
                <img @click="toDeposit" :src="require('../../assets/icon/wallert.png')" />
            </div>
            <img v-if="accountid != 0" class="me-icon sub-icon" @click="toMe"
                :src="require('../../assets/icon/me-top.png')" />
        </div>
    </div>
</template>
<script>
import md5 from 'js-md5';
export default {
    name: 'navheader',
    data() {
        return {
            lanCode: '',
            isShowLan: false
        }
    },
    created() {
        let lanCode = localStorage.getItem(md5('__lanCode__'))
        if (lanCode) {
            this.GLOBAL.lanCode = lanCode
        }
        this.lanCode = this.GLOBAL.lanCode
    },
    watch: {
        amount: {
            immediate: true,
            handler(newValue, oldValue) {
            }
        },
        accountid: {
            immediate: true,
            handler(newValue, oldValue) {

            }
        }
    },
    props: {
        amount: {
            type: String,
            default: '0.00'
        },
        accountid: {
            type: Number,
            default: 0
        },
        lanData: {
            type: Array,
            default: []
        }
    },
    computed: {

    },
    mounted() { },
    methods: {
        setLan(code) {
            this.$emit("setLan", code)
        },
        changeLan() {
            this.isShowLan = !this.isShowLan
        },
        func1() {

        },
        changeSlider() {
            this.$emit('changeSlider')
        },
        func1() {
        },
        toDeposit() {
            this.$emit('toDeposit')
        },
        toMe() {
            this.$emit('toMe')
        }
    }
}
</script>
<style lang="less" scoped>
.nav-header {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1;
    background: rgb(28, 32, 37);
    padding: 0 12px;
    height: 60px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;

    .sub-item {
        width: 35%;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        position: relative;
    }

    .main-item {
        width: 30%;
        font-size: 0;
    }

    .right-item {
        justify-content: flex-end !important;

        .lan-box {
            font-size: 0;
            position: relative;
        }

        .wallert {
            background-color: rgb(58, 64, 71);
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 8px;
            box-sizing: border-box;
            width: 100px;
            height: 26px;
            border-radius: 8px;

            div {
                font-size: 12px;
                color: #fff;
            }

            img {
                width: 15px;
                height: 15px;
            }
        }

        .me-icon {
            margin-left: 6px;
        }
    }

    .menu-icon {
        height: 22px;
        width: auto;
    }

    .sub-icon {
        height: 26px;
        width: auto;
    }

    .main-icon {
        height: 36px;
        width: auto;
    }

    .amount-modal {
        position: absolute;
        top: 58px;
        right: 10px;
        height: 70px;
        width: 90px;
        z-index: 999;
        background-color: rgb(44, 52, 62);
        color: #f6f6f6;

        div {
            height: 35px;
            line-height: 35px;
            margin: 0 10px;
            font-size: 13px;
        }

        div:not(:last-child) {
            border-bottom: 1px solid rgb(34, 40, 48);
        }
    }

    .amount-modal::before {
        content: "";
        display: inline-block;
        position: absolute;
        right: 12px;
        top: -9px;
        border-bottom: 10px solid rgb(44, 52, 62);
        border-right: 10px solid transparent;
        border-left: 10px solid transparent;
    }
}

.lan-masking {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 998;
    height: 100%;
    width: 100%;
}


.lan-modal::before {
    content: "";
    display: inline-block;
    position: absolute;
    right: 12px;
    top: -9px;
    border-bottom: 10px solid rgb(39, 44, 50);
    border-right: 10px solid transparent;
    border-left: 10px solid transparent;
}

.lan-modal {
    position: absolute;
    top: 50px;
    right: 12px;
    background-color: rgb(39, 44, 50);
    border-radius: 6px;

    .lan-item {
        width: 100%;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        position: relative;
        padding: 0 20px;
        box-sizing: border-box;
                border-bottom: 1px solid rgb(44, 50, 57);

        .icon {
            height: 30px;
            width: 30px;
            margin-right: 8px;
        }

        div {
            color: rgb(144, 151, 161);
            font-size: 16px;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/navheader/navheader.vue